export const PATOLOGY_MODULE = Symbol('PATOLOGY_MODULE')

export const PATOLOGY_API_KEY = Symbol('PATOLOGY_API_KEY')

export const PATOLOGY_SERVICE_KEY = Symbol('PATOLOGY_SERVICE_KEY')
